import React, { useEffect, useRef, useState } from 'react';
import './NPS.style.scss';
import { __NPSProps, __NPSRef } from './NPS.interface';
import { TextDirection } from 'interface';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPNPSRef extends __NPSRef {}

const SLPNPS: React.ForwardRefRenderFunction<__NPSRef, __NPSProps> = (props: __NPSProps, ref) => {
    const [value, setValue] = useState<number | null>(props.defaultValue ? props.defaultValue : null);
    const immediateValue = useRef<number | null>(value);
    const [hover, setHover] = useState<number | null>(null);
    const [error, setError] = useState<string>();
    const labelRef = useRef<HTMLLabelElement>(null);

    React.useImperativeHandle(ref, () => ({
        getValue: () => immediateValue.current,
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    const changeHandler = (e: number) => {
        immediateValue.current = e;
        setValue(immediateValue.current);
        setError(undefined);
        if (props.onChange) props.onChange(e);
    };

    function condition(index: number) {
        return (value !== null && value >= index) || (hover !== null && hover >= index);
    }

    return (
        <div className={`ucheck-SLP-NPS  ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}>
            <div className="NPS-header">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className="NPS-container">
                {Array.from(Array(11).keys()).map((item, index) => (
                    <span
                        onMouseEnter={() => setHover(index)}
                        onMouseLeave={() => setHover(null)}
                        key={index}
                        onClick={() => changeHandler(index)}
                        className={`${condition(index) ? 'active' : ''}`}
                        style={{
                            color: props.color,
                            borderColor: `${
                                props.color
                                    ? condition(index)
                                        ? props.color
                                        : props.color.length > 4
                                        ? props.color + '30'
                                        : props.color + '3'
                                    : ''
                            }`,
                        }}
                    >
                        {index}
                    </span>
                ))}
            </div>
            <div className="NPS-titles">
                <p className="end">{props.endTitle}</p>
                <p className="middle">{props.middleTitle}</p>
                <p className="start">{props.startTitle}</p>
            </div>
            {error && <p className="NPS-error">{error}</p>}
        </div>
    );
};

export default React.forwardRef(SLPNPS);
